export const apiUrl = 'https://boardsapitest.visionslive.com/';
export const vlqrApiUrl = 'https://apitest.visionslive.com/VL';
export const clientUrl = 'https://clienttest.visionslive.com';
